var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from './_default-imports';
import { PacemSafeContentElement } from './types';
//namespace Pacem.Components {
let PacemSpanElement = class PacemSpanElement extends PacemSafeContentElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'text' && !first) {
            this.textContent = val;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (!Utils.isNull(this.text)) {
            this.textContent = this.text;
        }
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemSpanElement.prototype, "text", void 0);
PacemSpanElement = __decorate([
    CustomElement({ tagName: P + '-span' })
], PacemSpanElement);
export { PacemSpanElement };
//}
